import { Select } from "antd";
import { PanelDocumentosAdministrativos } from "../../Documentosadministrativos/components/PanelDocumentosAdministrativos";
import { PanelDocumentosTecnicos } from "../../Documentostecnicos/components/PanelDocumentosTecnicos";
import {
  documentosDelPerfil,
  perfilParaDocumentos,
} from "../../../../utils/documentosDelPerfil";

interface IProps {
  convocatoria: any;
  categoria: any;
  cambioCategorias: (valor: any) => void;
  /** El perfil elegido, 1..3: decide que documentos aplican. */
  tipoParticipante?: number | null;
  /** Se avisa cuando se guarda un cambio en cualquiera de los dos grupos. */
  alCambiarDocumentos?: () => void;
}

/**
 * Segundo paso: la categoría y los documentos que exige la convocatoria.
 *
 * Los dos listados son los mismos componentes que usan las pantallas de
 * siempre; aquí van en una columna cada uno. En pantalla angosta se apilan,
 * administrativos primero.
 */
export const Paso2Documentos = ({
  convocatoria,
  categoria,
  cambioCategorias,
  tipoParticipante,
  alCambiarDocumentos,
}: IProps) => {
  const categorias = convocatoria?.categoria_linea_convocatoria ?? [];

  /**
   * Hay convocatorias que no piden documentos tecnicos, y otras que solo
   * los piden a algun perfil. Sin esto quedaba media pantalla en blanco al
   * lado de los administrativos.
   */
  const hayTecnicos =
    documentosDelPerfil(
      convocatoria?.documentos_tecnicos,
      perfilParaDocumentos(tipoParticipante)
    ).length > 0;

  return (
    <div className="container-fluid2">
      {/* La categoría va sola en su fila, así que se centra en vez de quedar pegada al borde. */}
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-8 col-lg-6 mb-3">
          <label
            htmlFor="categoria-propuesta"
            className="font-family-Montserrat-SemiBold font-size-14px mb-2 d-block"
          >
            Categoría <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            id="categoria-propuesta"
            style={{ width: "100%" }}
            placeholder="Seleccionar..."
            value={categoria}
            onChange={cambioCategorias}
          >
            {categorias.map(({ value, text }: any) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="row justify-content-center">
        <div
          className={hayTecnicos ? "col-12 col-lg-6" : "col-12 col-lg-8"}
          data-columna="administrativos"
        >
          {/*
            El panel trae el listado y los tres formularios que se diligencian
            en linea, con su propio estado. Se muestra sin la introduccion ni
            la navegacion, que aqui las pone el wizard.
          */}
          <PanelDocumentosAdministrativos
            mostrarIntro={false}
            mostrarNavegacion={false}
            alCambiarDocumentos={alCambiarDocumentos}
          />
        </div>

        {hayTecnicos && (
          <div className="col-12 col-lg-6" data-columna="tecnicos">
            {/*
              Igual que los administrativos: el panel trae el listado y el
              modal de escrito y video, con su propio estado.
            */}
            <PanelDocumentosTecnicos
              mostrarIntro={false}
              mostrarNavegacion={false}
              alCambiarDocumentos={alCambiarDocumentos}
            />
          </div>
        )}
      </div>
    </div>
  );
};
